import React, { useState } from "react";
import AnalysisComplete from "../components/layout/overview/AnalysisComplete";
import AnalysisHidden from "../components/layout/overview/AnalysisHidden";
import { FormCheckbox } from "shards-react";

const Overview = ({ user }) => {
  const [hide, setHide] = useState(false);

  if (!user) {
    return <></>;
  }

  if (user?.user?.privileges !== "admin") {
    return <></>;
  }

  return (
    // Switch to change the content of the overview
    <>
      <div
        style={{
          marginLeft: 10,
          marginTop: 10,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <FormCheckbox checked={hide} onChange={() => setHide(!hide)}>
          {hide ? "Mostrar contenido sensible" : "Esconder contenido sensible"}
        </FormCheckbox>
      </div>
      {hide ? <AnalysisHidden user={user} /> : <AnalysisComplete user={user} />}
    </>
  );
};

export default Overview;
